import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CORGI_ALLOW_IFRAME_EMBEDDING = defineFcm('corgi_allow_iframe_embedding')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			shape: {
				type: 'object',
				shape: {
					allowedAncestorDomains: {
						type: 'array',
						shape: { type: 'string' },
					},
				},
			},
		}),
	)
	.withDefault({})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'iframe policies for Corgi apps',
		description: `This can be used to allow specific domains to iframe embed specific Corgi pages.

	The key is the page's route id. The route id can be retrieved from https://www.staging-change.org/corgi/stats/routes.html`,
		template: {
			topic: {
				allowedAncestorDomains: ['www.change.vote'],
			},
		},
	});
